import { useState } from 'react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Calendar } from '@/components/ui/calendar';

import { DateRange } from 'react-day-picker';

interface CustomPeriodFilterProps {
  onPeriodChange?: (period: DateRange | undefined) => void;
}

export const CustomPeriodFilter = ({ onPeriodChange }: CustomPeriodFilterProps) => {
  const [date, setDate] = useState<DateRange | undefined>();
  const [isOpen, setIsOpen] = useState(false);

  const handleDateChange = (newDate: DateRange | undefined) => {
    setDate(newDate);
    onPeriodChange?.(newDate);
  };

  const formatDateRange = (dateRange: DateRange | undefined) => {
    if (!dateRange?.from) return "Période personnalisée";
    
    if (!dateRange.to) {
      return format(dateRange.from, "d MMM", { locale: fr });
    }
    
    // Si c'est le même jour
    if (dateRange.from.toDateString() === dateRange.to.toDateString()) {
      return format(dateRange.from, "d MMM", { locale: fr });
    }
    
    return `${format(dateRange.from, "d MMM", { locale: fr })} - ${format(dateRange.to, "d MMM", { locale: fr })}`;
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <div className="p-3 bg-white rounded-[10px] outline outline-1 outline-offset-[-1px] outline-neutral-400/20 flex justify-center items-center gap-1 cursor-pointer hover:outline-neutral-400/40 transition-all">
          <div data-svg-wrapper className="relative">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.33325 6.66669V9.33335H9.99992" stroke="#FF7F50" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7.33325 9.33334L8.35659 8.26334C8.73928 7.89554 9.20427 7.62445 9.71287 7.47262C10.2215 7.32079 10.759 7.29261 11.2807 7.39043C11.8024 7.48824 12.2932 7.70923 12.7122 8.03499C13.1313 8.36076 13.4665 8.78189 13.6899 9.26334M10.6666 1.33334V4.00001M13.9999 12L12.9766 13.07C12.5939 13.4378 12.1289 13.7089 11.6203 13.8607C11.1117 14.0126 10.5742 14.0407 10.0525 13.9429C9.53081 13.8451 9.04002 13.6241 8.62096 13.2984C8.20191 12.9726 7.86671 12.5515 7.64325 12.07" stroke="#FF7F50" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14 14.6667V12H11.3333M14 5.66668V4.00001C14 3.64639 13.8595 3.30725 13.6095 3.0572C13.3594 2.80715 13.0203 2.66668 12.6667 2.66668H3.33333C2.97971 2.66668 2.64057 2.80715 2.39052 3.0572C2.14048 3.30725 2 3.64639 2 4.00001V13.3333C2 13.687 2.14048 14.0261 2.39052 14.2762C2.64057 14.5262 2.97971 14.6667 3.33333 14.6667H6.2M2 6.66668H4.66667M5.33333 1.33334V4.00001" stroke="#FF7F50" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="justify-center text-gray-800 text-xs font-medium font-['Bricolage_Grotesque'] whitespace-nowrap">
            {date?.from ? formatDateRange(date) : "Période personnalisée"}
          </div>
          <div data-svg-wrapper className="relative">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.3334 6.66667L8.00008 10L4.66675 6.66667" stroke="#8F949D" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="end">
        <div className="p-4">
          <Calendar
            mode="range"
            selected={date}
            onSelect={handleDateChange}
            numberOfMonths={2}
            locale={fr}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
};